import React from 'react'

const Services = () => {
  const services = [
    {
      icon: 'fas fa-chalkboard-teacher',
      title: 'کلاس‌ها',
      description: 'تدریس خصوصی ، تدریس حضوری و تدریس آنلاین.'
    },
    {
      icon: 'fas fa-book-open',
      title: 'آموزش آنلاین',
      description: 'کمک در تکالیف و پروژه های درسی مدارس و دانشگاه.'
    },
    {
      icon: 'fas fa-user-graduate',
      title: 'کمک آموزش',
      description: 'راهنمایی برای انتخاب مسیر تحصیلی متناسب با اهداف دانش‌آموز.'
    },
    {
      icon: 'fas fa-question-circle',
      title: 'رفع اشکلات',
      description: 'بررسی مفاهیم دشوار و پاسخ به سوالات درسی برای درک بهتر مطالب.'
    }
  ]

  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">خدمات آموزشی</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card card-base card-light-sweep card-overlay">
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services 